var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import styled from 'styled-components';
import { ToggleButton } from "../controls/ToggleButton";
import { Text } from "../Text";
import { STACK_ALIGN, STACK_GAP, StackView } from "../StackView";
import { useStateValue, SPACING_M, SPACING_XXL, createUIElement } from "../helpers";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    box-sizing: border-box;\n    height: ", ";\n    padding: 0 ", ";\n"], ["\n    display: inline-flex;\n    box-sizing: border-box;\n    height: ", ";\n    padding: 0 ", ";\n"])), SPACING_XXL, SPACING_M);
export var BasicFilter = createUIElement('BasicFilter', function (_a, ref) {
    var className = _a.className, label = _a.label, buttons = _a.buttons, _b = _a.value, selectedItems = _b === void 0 ? [] : _b, onChange = _a.onChange, _c = _a.hasAllButton, hasAllButton = _c === void 0 ? false : _c, _d = _a.textAllButton, textAllButton = _d === void 0 ? 'All' : _d, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "label", "buttons", "value", "onChange", "hasAllButton", "textAllButton", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _e = useStateValue(selectedItems, [selectedItems]), getValue = _e.getValue, setValue = _e.setValue;
    var updateValue = function (value, isToggled) {
        var currentValue = __spreadArrays(getValue());
        var isIdSelected = currentValue.includes(value);
        if (!isToggled && isIdSelected) {
            return currentValue.filter(function (i) { return i !== value; });
        }
        if (isToggled && !isIdSelected) {
            currentValue.push(value);
        }
        return currentValue;
    };
    var handleChangeValue = function (value, isToggled) {
        var newValue = updateValue(value, isToggled);
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var handleAllChangeValue = function (isToggled) {
        if (isToggled) {
            setValue([]);
            onChange === null || onChange === void 0 ? void 0 : onChange([]);
        }
    };
    var isAllButtonToggled = getValue().length === 0;
    return (React.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'basicfilter', className: "vm-BasicFilter " + className, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { align: STACK_ALIGN.center, gap: STACK_GAP.m },
            React.createElement(Text, null,
                label,
                ":"),
            hasAllButton && (React.createElement(ToggleButton, { "data-selector-id": "basicfilter-toggle-button-all", isToggled: isAllButtonToggled, onChange: handleAllChangeValue }, textAllButton)),
            buttons.map(function (_a, idx) {
                var title = _a.title, value = _a.value, disabled = _a.disabled, rest = __rest(_a, ["title", "value", "disabled"]);
                return (React.createElement(ToggleButton, { key: "basicfilter-toggle-button-" + idx, "data-selector-id": "basicfilter-toggle-button-" + idx, icon: rest['icon'], title: title, isToggled: getValue().includes(value), onChange: function (isToggled) {
                        return handleChangeValue(value, isToggled);
                    }, disabled: disabled }, rest['text']));
            }))));
});
var templateObject_1;
//# sourceMappingURL=BasicFilter.js.map